import React from "react";
import { FaDiscord, FaTwitter } from "react-icons/fa";

const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-gray-500 py-10 border-t">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* Resources Section */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-700 mb-4">
              Resources
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://vendororbis.featurebase.app/changelog"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  Changelog
                </a>
              </li>
              <li>
                <a
                  href="https://vendororbis.featurebase.app/"
                  className="hover:text-gray-900"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Suggestions
                </a>
              </li>
              <li>
                <a href="/faq" className="hover:text-gray-900">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-700 mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/terms-and-condition" className="hover:text-gray-900">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-gray-900">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/eula" className="hover:text-gray-900">
                  EULA
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t my-6"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} VendorOrbis, LLC. All rights
            reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a
              href="https://discord.gg/UQmQw3bnhs"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-900"
            >
              <FaDiscord size={20} />
            </a>
            <a
              href="https://x.com/vendororbis"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-900"
            >
              <FaTwitter size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

